export const SettleAmountCalculateEnum = {
  /**下发总额*服务费率 1 */
  SETTLE_AMOUNT_CALCULATE_WAY_1: 1,
  /**每人下发金额*服务费率，四舍五入再求和 2 */
  SETTLE_AMOUNT_CALCULATE_WAY_2: 2,
  /**每人下发金额*服务费率，向下取两位小数 3 */
  SETTLE_AMOUNT_CALCULATE_WAY_3: 3,
  /**下发总额*服务费率，向上取两位小数 4 */
  SETTLE_AMOUNT_CALCULATE_WAY_4: 4,
};

export const SettleAmountCalculateWayOptions = [
  // 服务费计算方式下拉选数据
  {
    text: "下发总额*服务费率",
    value: SettleAmountCalculateEnum.SETTLE_AMOUNT_CALCULATE_WAY_1,
  },
  {
    text: "每人下发金额*服务费率，四舍五入再求和",
    value: SettleAmountCalculateEnum.SETTLE_AMOUNT_CALCULATE_WAY_2,
  },
  {
    text: "每人下发金额*服务费率，向下取两位小数",
    value: SettleAmountCalculateEnum.SETTLE_AMOUNT_CALCULATE_WAY_3,
  },
  {
    text: "下发总额*服务费率，向上取两位小数",
    value: SettleAmountCalculateEnum.SETTLE_AMOUNT_CALCULATE_WAY_4,
  },
];
